<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">Lysette Maison is a mother of two and grandmother of three. After retiring from the NHS as a medical secretary, she took a long vacation, travelling to various countries, which inspired her to write her books. Her first book, <em>Invisible Liaison</em>, was set in Syria, India and America. Her second book, <em>Devil’s Bin</em>, is set in Yellowknife in the Northern Territories of Canada. Visiting these countries inspired her to write the stories and give an accurate account of the environment in which they are based. Her next book, <em>Red Scarab,</em> which she is working on at present, is set in Egypt and England.</p>
<br/>
<p style="text-indent:0em;">Lysette is a passionate writer and writes from the heart, which makes for interesting yet true-to-life stories people can relate to.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?242e5258